export interface PortfolioProject {
  id: number;
  title: string;
  category: 'ALL' | 'WEBSITE' | 'E-COMMERCE' | 'TRAVEL' | 'REAL ESTATE';
  description: string;
  url: string;
  image: string;
  alt: string;
}

export const portfolioProjects: PortfolioProject[] = [
  {
    id: 1,
    title: 'Kameswari Jewellers',
    category: 'WEBSITE',
    description: 'A luxury jewellery brand experience built for product storytelling and elegant browsing.',
    url: 'https://kameswarijewellers.in',
    image: '/portfolio-1.png',
    alt: 'Jewellery website with premium gold rings and elegant product display',
  },
  {
    id: 2,
    title: 'Talbots',
    category: 'E-COMMERCE',
    description: 'A premium fashion storefront with strong seasonal merchandising and conversion-driven UX.',
    url: 'https://www.talbots.com/',
    image: '/portfolio-2.png',
    alt: 'Fashion e-commerce website landing with apparel collection visuals',
  },
  {
    id: 3,
    title: 'Yours Clothing',
    category: 'E-COMMERCE',
    description: 'A modern apparel shopping experience designed to highlight style, fit, and product discovery.',
    url: 'https://www.yoursclothing.com/',
    image: '/portfolio-3.png',
    alt: 'Online clothing store product showcase with fashion visuals',
  },
  {
    id: 4,
    title: 'Beauty Barn',
    category: 'E-COMMERCE',
    description: 'A beauty retail storefront built for mobile-first browsing and premium brand positioning.',
    url: 'https://beautybarn.in/',
    image: '/portfolio-4.png',
    alt: 'Beauty products website with vibrant lifestyle imagery',
  },
  {
    id: 5,
    title: 'Sunsama',
    category: 'WEBSITE',
    description: 'A productivity brand website with clean content layout and onboarding-ready messaging.',
    url: 'https://www.sunsama.com/',
    image: '/portfolio-5.png',
    alt: 'Productivity app website hero layout with soft white space',
  },
  {
    id: 6,
    title: 'Two Good',
    category: 'WEBSITE',
    description: 'A sustainable food brand website with bold storytelling and a modern visual system.',
    url: 'https://twogood.com.au/',
    image: '/portfolio-6.png',
    alt: 'Food brand website with lifestyle imagery and bold typography',
  },
  {
    id: 7,
    title: 'Aykyam',
    category: 'TRAVEL',
    description: 'A travel and lifestyle site built for immersive destination discovery and bookings.',
    url: 'https://aykyam.com/',
    image: '/portfolio-7.png',
    alt: 'Travel website hero image with destination inspiration',
  },
  {
    id: 8,
    title: 'AIT Square',
    category: 'REAL ESTATE',
    description: 'A Dubai real estate website showcasing property investment and premium brokering services.',
    url: 'https://aitsquare.com/',
    image: '/portfolio-8.png',
    alt: 'Real estate website featuring Dubai property visuals',
  },
  {
    id: 9,
    title: 'DEKOR Company',
    category: 'WEBSITE',
    description: 'A design and interiors site built for high-end creative services and portfolio storytelling.',
    url: 'https://www.dekorcompany.com/',
    image: '/portfolio-9.png',
    alt: 'Interior design website layout with elegant visuals',
  },
  {
    id: 10,
    title: 'Discit Game',
    category: 'WEBSITE',
    description: 'A gaming brand website with bold visuals and a playful interactive experience.',
    url: 'https://www.discitgame.com/',
    image: '/portfolio-10.png',
    alt: 'Gaming brand website with immersive graphics',
  },
  {
    id: 11,
    title: 'Welcome to Yellow',
    category: 'WEBSITE',
    description: 'A creative media experience site with strong editorial content and color-forward design.',
    url: 'https://welcometoyellow.com/',
    image: '/portfolio-11.png',
    alt: 'Creative brand website with vibrant editorial visuals',
  },
  {
    id: 12,
    title: 'AX Realtors',
    category: 'REAL ESTATE',
    description: 'A premium real estate platform for luxury Dubai property listings and concierge services.',
    url: 'https://www.axrealtors.com/',
    image: '/portfolio-12.png',
    alt: 'Luxury real estate property image with modern architecture',
  },
  {
    id: 13,
    title: 'Amberwood Doors',
    category: 'E-COMMERCE',
    description: 'A premium e-commerce storefront for custom wood doors and luxury manufacturing.',
    url: 'https://amberwooddoors.com/',
    image: '/portfolio-13.png',
    alt: 'Custom wood door e-commerce product display',
  },
  {
    id: 14,
    title: 'Wecation UAE',
    category: 'TRAVEL',
    description: 'A travel booking platform for UAE experiences with immersive destination content.',
    url: 'https://wecation.ae/',
    image: '/portfolio-14.png',
    alt: 'Vacation destination imagery with luxury travel styling',
  },
  {
    id: 15,
    title: 'Vardhan Oil',
    category: 'E-COMMERCE',
    description: 'A business e-commerce site for industrial oil products and B2B ordering.',
    url: 'https://vardhanoil.com/',
    image: '/portfolio-15.png',
    alt: 'Industrial oil products website imagery',
  },
  {
    id: 16,
    title: 'T&J Capital',
    category: 'REAL ESTATE',
    description: 'A luxury Dubai real estate portal showcasing premium off-plan off-market villas and apartments.',
    url: 'https://tandjcapital.com/',
    image: '/portfolio-16.png',
    alt: 'Luxury Dubai real estate portal showcasing premium off-plan off-market properties',
  },
  {
    id: 17,
    title: 'Venduras',
    category: 'TRAVEL',
    description: 'A high-end smart homes villa and hotel stay booking engine integrated with live calendar sync.',
    url: 'https://venduras.com/',
    image: '/portfolio-17.png',
    alt: 'Premium hotel and vacation stay booking page visual',
  },
];
